/**
 * Schema options for header widgets.
 * Category fields are now free-text (any Web Map layer field name).
 * These defaults provide starter options for common field names.
 */
export const HEADER_CATEGORY_SCHEMA_OPTIONS: {
  value: string;
  label: string;
}[] = [
  { value: 'type', label: 'Type' },
  { value: 'category', label: 'Category' },
  { value: 'status', label: 'Status' },
  { value: 'name', label: 'Name' },
];

export const HEADER_CATEGORY_DEFAULT_LABEL: Record<string, string> = {
  type: 'Type',
  category: 'Category',
  status: 'Status',
  name: 'Name',
};

export const HEADER_CATEGORY_DEFAULT_PLACEHOLDER: Record<string, string> = {
  type: 'All types',
  category: 'All categories',
  status: 'All statuses',
  name: 'All',
};

export const HEADER_NUMBER_METRIC_OPTIONS: { value: string; label: string }[] = [
  { value: 'feature_count', label: 'Feature count (bound layer)' },
];
